import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsWechatComponent } from './simple-icons-wechat.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsWechatComponent ],
    exports:      [ SimpleIconsWechatComponent ],
    bootstrap:    []
})
export class SimpleIconsWechatModule {}
